// Components
import { Box, Flex, Text } from 'yard-utilities/components'
import SvgBox from '@components/helpers/SvgBox'
import ListItem from '@components/v21/common/list-item/ListItem'
import Tag from '@components/v25/common/tag/Tag'
import Span from '@components/v21/common/span/Span'
import CreateAccount from './create-account/CreateAccount'
import FullRefundBanner from '@components/v25/es/ft1/full-refund-banner/FullRefundBanner'

// Icons
import { CheckmarkCircle } from 'icons/v21/Icons'

// Styles
import styles from './MembershipCard.module.sass'

const features = [
  'Acceso instantáneo al sistema RatePunk',
  'Alertas ilimitadas de notificaciones de vuelo',
  'Vuelos en temporada alta y días festivos',
  '30 días de garantía de devolución del dinero',
  'Cancela en cualquier momento'
]

interface MembershipWrapperProps {
  redirectURL?: string
}

const MembershipWrapper = ({
  redirectURL = '/v25/es/payment'
}: MembershipWrapperProps) => {
  return (
    <Box
      backgroundColor="yellow-10"
      borderRadius={{ sm: [16] }}
      shadow="shadowDefault"
      className={styles.section}
    >
      <Flex flexDirection="column" rowGap={{ sm: 24 }}>
        <Box
          className={styles.container}
          overflow="hidden"
          padding={{ sm: [32, 24, 8] }}
          borderRadius={{ sm: [16, 16, 0, 0] }}
        >
          <div className={styles.content}>
            <Text
              tagName="h3"
              variant="title-2"
              spacing={{ sm: 4 }}
              align="center"
              transform="uppercase"
            >
              Membresía de 1 año
            </Text>
            <Text
              tagName="p"
              variant="body-3"
              spacing={{ sm: 24 }}
              align="center"
              textColor="grey-2"
            >
              Facturación anual
            </Text>

            <Flex flexDirection="column" alignItems="center" rowGap={{ sm: 4 }}>
              <Box spacing={{ sm: 4 }}>
                <Tag backgroundColor="red" variant="type-3" textSize="body-3">
                  Ahorra un 77%
                </Tag>
              </Box>

              <Flex columnGap={{ sm: 8 }} alignItems="center">
                <Text
                  tagName="p"
                  variant="body-4"
                  textColor="grey-2"
                  decoration="lineThrough"
                >
                  $2
                </Text>
                <Text tagName="p" variant="title-6">
                  $0,46 <Span variant="title-4">USD</Span>
                </Text>
              </Flex>

              <Text tagName="p" variant="body-3" textColor="grey-2">
                por semana
              </Text>
            </Flex>
          </div>
        </Box>

        <Box padding={{ sm: [0, 24, 32] }}>
          <Flex flexDirection="column" rowGap={{ sm: 48 }}>
            <Flex flexDirection="column" rowGap={{ sm: 16 }}>
              {features.map((item, i) => (
                <ListItem
                  key={i}
                  icon={
                    <SvgBox offset={3}>
                      <CheckmarkCircle color="#00B67A" />
                    </SvgBox>
                  }
                  textSize="body-1"
                  fontWeight={400}
                  gap={[8]}
                  position="flex-start"
                >
                  {item}
                </ListItem>
              ))}
            </Flex>

            <FullRefundBanner />

            <CreateAccount redirectURL={redirectURL} />
          </Flex>
        </Box>
      </Flex>
    </Box>
  )
}

export default MembershipWrapper
